import { Icon, RHFTextField } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import { Controller } from 'react-hook-form';
import { TaxIdDropdown } from '../../../tax-id-dropdown';
import * as Styled from './styles';
import * as SX from './sx';
import type { TaxIdRowProps as Props } from './types';

export const TaxIdRow = memo(
  ({ className, rowIndex, control, getIsExisting, onRemove }: Props) => {
    const isExisting = getIsExisting(rowIndex);

    return (
      <Styled.Wrapper
        className={classnames('TaxIdRow', className)}
        sx={SX.root}
      >
        <Controller
          name={`taxIds.${rowIndex}.type`}
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TaxIdDropdown
              {...field}
              value={field.value === '' ? undefined : field.value}
              disabled={isExisting}
            />
          )}
        />
        <RHFTextField
          variant="outlined"
          size="small"
          fullWidth
          name={`taxIds.${rowIndex}.value`}
          placeholder="Enter Tax ID"
          hiddenLabel
          disabled={isExisting}
        />
        <Box sx={SX.icon} onClick={() => onRemove()}>
          <Icon name="close" size={20} />
        </Box>
      </Styled.Wrapper>
    );
  }
);

TaxIdRow.displayName = 'TaxIdRow';
